var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live-detail-component"},[(_vm.getGameConsole === 'default')?_c('default-live-event-detail'):_vm._e(),(
      _vm.getGameConsole === 'marketview' &&
      (_vm.getPlatformId === 54 ||
        _vm.getPlatformId === '54' ||
        _vm.getPlatformId === 99 ||
        _vm.getPlatformId === '99')
    )?_c('market-view-live-event-detail'):(_vm.getGameConsole === 'marketview')?_c('market-view-event-live-detail-config-from-settings'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }